import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { PROVIDERS, MODULES } from "./app.imports";

import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";

import { MyApp } from "./app.component";

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: "",
      backButtonIcon: "ios-arrow-round-back",
      iconMode: "ios",
      tabsPlacement: "bottom",
      pageTransition: "ios",
      mode: "ios",
      swipeBackEnabled: false,
      scrollAssist: false,
      autoFocusAssit: false,
    }),
    MODULES,
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    StatusBar,
    SplashScreen,
    PROVIDERS,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts